// src/clarityUtils.ts
export const setClarityTag = (key: string, value: string) => {
    if (window.clarity) {
        window.clarity('set', key, value);
    }
};
